import React from "react";
import { Card } from "../modules/Products";

export function ProductCardPage(props) {
  return <Card {...props} />;
}
